import { Component, Input } from "@angular/core"
import { LearningObject } from "../../../models/learningObject.model"

@Component({
    selector: "app-featured-collections-browse",
    templateUrl: "./featured-collections.component.html",
    styleUrls: ["./featured-collections.component.scss"],
    standalone: false,
})
export class FeaturedCollectionsComponent {
    @Input() collectionTitle: string = ""
    @Input() featuredCollections: LearningObject[] = []
    gtmPrefix = "gtm-browse-featured-collections"

    constructor() {}
}
